<template>
  <div id="app">
    <el-container style="height:100%;background-color:#395774">
      <el-header v-if="this.$route.path!=='/pointpro'&&this.$route.path!=='/pointlog'&&this.$route.path!=='/notice'&&this.$route.path!=='/vip'">
        <div>水安将军单位参赛情况后台管理系统</div>
        <p class="logout"
           @click="logout">退出登录</p>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {
  },
  data () {
    return {

    };
  },
  methods: {
    logout () {
      localStorage.clear('dwform')
      this.$router.push("/")
    }
  }
};
</script>

<style lang="less">
.useritem{
  .el-button{
    margin-top: 10px;
  }
}
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: #eef1f6;
    margin-right: -10px
}

::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: rgba(6,232,240,.022)
}
html,
body,
#app {
  height: 100%;
  margin: 0px;
  padding: 0px;
}
.fade-leave-to {
  display: none;
}
.el-header {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
  color: white;
  letter-spacing: 2px;
  position: relative;
  .logout {
    position: absolute;
    top: 50%;
    right: 0%;
    margin-right: 2%;
    transform: translateY(-50%);
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    padding: 5px;
    border-bottom: 1px solid #fff;
  }
  p {
  }
}
.el-descriptions {
  width: 100%;
}

.el-table--small {
  .el-table__cell {
    padding: 2px 0 !important;
  }
}
.el-tabs--border-card {
  & > .el-tabs__content {
    padding: 0 !important;
  }
  & > .el-tabs__header {
    border-bottom: none !important;
  }
}
.content-wrap {
  height: 790px;
  background-color: rgba(255, 255, 255, 0.8);
  position: relative;
}
.el-tabs__header {
  margin: 0 !important;
  background-color: rgba(255, 255, 255, 0.8);
}
.el-tabs__nav {
  .is-active {
    color: rgb(255, 255, 255) !important;
    background: rgb(47, 166, 240) !important;
  }
}
.el-tabs--border-card {
  border: none !important;
}
.el-table__row--striped {
  td {
    background-color: #dddddd !important;
  }
}
main {
  & > div {
    border-radius: 5px;
    overflow: hidden;
  }
}
.el-tabs__item {
  text-align: center;
  padding: 0 20px !important;
}
.el-button {
  height: 24px;
  line-height: 24px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  /* margin: 12px 0 !important; */
}
.export {
  .el-form-item__content {
    .xx {
      line-height: 24px;
      margin-right: 20px;
    }
  }
}
.el-popconfirm__action {
  display: flex;
  justify-content: flex-end;
  .el-button--text {
    margin-right: 20px!important;
  }
}

@media screen and (max-width: 530px) {
  .el-header {
    font-size: 18px !important;
  }
  .logout {
    font-size: 14px !important;
    top: 70% !important;
  }
  .useritem {
    width: 300px !important;
    .el-button {
      top: 40%;
      right: 1%;
    }
  }
}
.search {
  /* position: absolute;
  z-index: 999;
  right: 2%;
  top: 0px; */
  margin-right: 20px;
  .el-input__inner {
    height: 26px !important;
  }
}
.header {
  width: 100%;
  overflow-x: auto;
  display: flex;
  padding: 0 20px;
}
</style>
